const NotFound = () => {
    return ( 
        <div className="not-found">
            <h2>404</h2>
            <p>Page Not Found</p>
        </div>
     );
}
 
export default NotFound;